<template>
  <EquipmentConfigField
    v-model="context.value.value[props.field.key]"
    v-bind="props"
  />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import EquipmentConfigField from '@/components/common/forms/editor-fields/EquipmentConfigField.vue'

import { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
